<template>
    <div id="CommonProblem" class="wrap">
        <van-nav-bar
        :fixed="true"
        placeholder
        :title="$t('My.CommonProblem.CommonProblem')"
        left-arrow
        @click-left="onClickLeft"
        />
        <div class="content">
            <div class="Text">
                <p class="p-text">{{$t('My.CommonProblem.One')}}</p>
                <br>
                <p><strong>A：</strong>{{$t('My.CommonProblem.Two')}}</p>
                <br>
                <p class="p-text">{{$t('My.CommonProblem.Three')}}</p>
                <br>
                <p><strong>A：</strong>{{$t('My.CommonProblem.Four')}}</p>
                <br>
                <p class="p-text">{{$t('My.CommonProblem.Five')}}</p>
                <br>
                <p><strong>A：</strong>{{$t('My.CommonProblem.Six')}}</p>
                <br>
                <p class="p-text">{{$t('My.CommonProblem.Seven')}}</p>
                <br>
                <p><strong>A：</strong>{{$t('My.CommonProblem.Eight')}}</p>
                <br>
                <p class="p-text">{{$t('My.CommonProblem.Nine')}}</p>
                <br>
                <p><strong>A：</strong>{{$t('My.CommonProblem.Ten')}}</p>
                <br>
                <p class="p-text">{{$t('My.CommonProblem.Eleven')}}</p>
                <br>
                <p><strong>A：</strong>{{$t('My.CommonProblem.Twelve')}}</p>
                <br>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        Row,
        Col,
        Icon,
        Cell,
        GridItem,
        Grid,
        NavBar,
        ActionSheet,
        Button,
        Image 
    }from "vant";

    export default {
        name:"CommonProblem",
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [GridItem.name]: GridItem,
            [Grid.name]: Grid,
            [NavBar.name]: NavBar,
            [ActionSheet.name]: ActionSheet,
            [Button.name]: Button,
            [Image.name]:Image
        },
        data(){
            return{
                
            }
        },
        methods:{
            // 返回上一个路由
            onClickLeft(){
                this.$router.go(-1);
            },
        
        },
        created() {
            window.scroll(0, 0);
        },
    }
</script>

<style lang="less">
    #CommonProblem{
        width: 100%;
        height: 100%;
        .content{
            width: calc(100% - 1.25rem);
            padding: 0.9375rem 0.625rem;
            background-color: #f2f2f2;
            >.Text{
                width: calc(100% - 1.25rem);
                padding: 1.25rem 0.625rem;
                border-radius: 0.625rem;
                background-color: #fff;
                font-size: 14px;
                color: #333;
                .p-text{
                    font-weight: 700;
                }
            }
        }
    }
</style>